'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SESSION_EXPIRY_TIME_APPROXIMATION_IN_MS = exports.SESSION_EXPIRY_TIME_APPROXIMATION_IN_MS = 30 * 60 * 1000;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/thread-history/constants/ThreadHistoryConstants.js
// module id = 382
// module chunks = 2 3